﻿import {UIText} from "../Base/UIText";
import {UISprite} from "../Base/UISprite";
import {RewardType} from "../../../enums";
import {Core} from "../../../Base/Core";
import {GameManager} from "../../../Game/GameManager";
import {gsap} from "gsap";

export class RouletteItem extends UISprite {

    Awake() {
        super.Awake();

        this.bgActiveContainer = this.addChild(new PIXI.Container);
        this.bgActive = this.bgActiveContainer.addChild(new UISprite(PIXI.Texture.WHITE));
        this.bgActive.alpha = 0.3;
        this.bgActive.SetActive(false);

        this.border = this.addChild(new PIXI.Graphics());

        this.icon = this.addChild(new UISprite());
        this.label = this.addChild(new UIText());
        this.lightAnimation = null; // Animation lightAnimation;

        this._rect = new PIXI.Rectangle;
    }

    SetItem(item, changeBg) {
        if (this.item === item) return;
        this.item = item;
        switch (item.type) {
            case RewardType.MoneyHard:
                this.icon.setImage("ico-diamond");
                this.label.text = item.value;
                break;
            case RewardType.MoneySoftBySoftSpeed:
                this.icon.setImage("ico-gold");
                this.label.text = NUtils.FormatMoney(item.value * GameManager.gameController.MoneySoftSpeed);
                break;
            case RewardType.RandomCreatureFromCurrentEpoch:
                this.icon.setImage("box");
                this.label.text = Core.Localizator.Get("random_monster");
                break;
            case RewardType.BoosterIncomeX4:
                this.icon.setImage("x4");
                this.label.text = Math.ceil(item.valueInt / 60) + " " + Core.Localizator.Get("minutes");
                break;
            case RewardType.BoosterCreaturesDiscount:
                this.icon.setImage("upgrades/booster-monstersale-ico");
                this.label.text = Math.ceil(item.valueInt / 60) + " " + Core.Localizator.Get("minutes");
                break;
            default:
                this.icon.setImage("");
                this.label.text = "";
                break;
        }
        this._fitSize();
    }

    _fitSize() {
        let rect = this._rect;

        this.bgActiveContainer.position.set(rect.x + rect.width * 0.5, rect.y + rect.height * 0.5);
        let bgActiveRect = rect.clone();
        bgActiveRect.x = -rect.width * 0.5;
        bgActiveRect.y = -rect.height * 0.5;
        this.bgActive.anchor.set(0.5, 0.5);
        this.bgActive.fitRect(rect);
        this.bgActive.position.set(0, 0);

        this.border.clear().lineStyle(1, 0xFFFFFF, 1).drawRect(rect.x, rect.y, rect.width, rect.height);

        let iconRect = rect.clone().pad(-rect.height * 0.2);
        iconRect.y = rect.height * 0.1;
        this.icon.fitRect(iconRect);

        let labelRect = rect.clone().pad(0, -rect.height * 0.4);
        labelRect.y = rect.bottom - labelRect.height;
        this.label.fitLayout(labelRect);
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);
        this._rect.copyFrom(parentRect);
        this._rect.x = this._rect.y = 0;
        this._fitSize();
    }

    PlayChooseAnimation() {
        this.bgActiveContainer.scale.set(0);
        this.bgActive.SetActive(true);
        gsap.timeline()
            .to(this.bgActiveContainer, {pixi: {scale: 1.2}, duration: 0.3})
            .to(this.bgActiveContainer, {pixi: {scale: 1}, duration: 0.2})
    }

    ClearChooseAnimation() {
        this.bgActive.SetActive(false);
    }
}
